<template>
  <div class="details" v-if="list">
    <h1 class="line">
      {{list.Title}}
      <div v-if="list.OrderType!=1">
        <span :class="getCountDown(list.EffectiveTime)==1?'text_red':''">{{$t('colon.timeLeft')}} <em>{{CountDown(list.EffectiveTime,0)}}</em></span>{{list.EffectiveTime |setTime}}
      </div>
      <div v-if="list.OrderType==1&&list.ReleaseType==1&&CountDown(list.LastOnTime)!='00:00'" class="OrderType">{{$t('colon.StartingTime')}} {{list.LastOnTime|setTime}} <span :class="getCountDown(list.LastOnTime)==1?'text_red':''">{{$t('colon.timeLeft')}} <em>{{CountDown(list.LastOnTime,0)}}</em></span></div>
    </h1>
    <div class="line price_btn_box">
      <div class="price_btn_box">
        <div class="price_list_box">
          <div class="price_list">
            <span class="price_default">{{$t('colon.price')}}</span>
            <div class="price_us">{{areaSymbol}} {{list.USD_Price}}</div>
          </div>
        </div>
      </div>
      <div class="detail_btn_box" v-if="userInfo!=null&&list.SellUserID!=userInfo.MappingUserId">
        <!-- 普通 -->
        <div class="detail_btn primary" @click="goto" v-if="list.OrderType!=1">{{$t('base.buyNow')}}</div>
        <!-- 正常 -->
        <div class="detail_btn primary" v-if="list.Bargain==1&&list.PriceCount==3&&userInfo.Count>0&&userInfo.TelPhone" @click="dialogVisible=true">{{$t('base.makeOffer')}}
        </div>
        <router-link class="detail_btn primary" v-if="list.Bargain==1&&list.PriceCount!=3&&userInfo.Count>0&&userInfo.TelPhone" :to="{path:'/mycardhobby/offerhistory/'+list.ID}">{{$t('base.makeOffer')}}</router-link>
        <div class="detail_btn primary" v-if="list.Bargain==1&&list.PriceCount==3&&userInfo.Count<=0" @click="isAddCout">{{$t('base.makeOffer')}}</div>
        <div class="detail_btn" v-if="list.OrderType!=1" @mousemove="setwatch(isWatchlist,1)" @mouseout="setwatch(isWatchlist,0)">
          <div class="collec" :class="isWatchlist?'on':''" @click="setAttention">{{watchName}}</div>
        </div>
      </div>
      <div class="detail_btn_box" v-if="userInfo!=null&&list.SellUserID==userInfo.MappingUserId&&userInfo.VerifyStatus==2">
      </div>
      <div class="detail_btn_box" v-if="userInfo!=null&&list.SellUserID==userInfo.MappingUserId&&userInfo.VerifyStatus!=2">
      </div>
      <div class="detail_btn_box" v-if="userInfo==null">
        <router-link class="detail_btn primary" :to="{path:'/login'}">{{$t('base.buyNow')}}</router-link>
        <router-link class="detail_btn" v-if="list.OrderType==1" :to="{path:'/login'}">{{$t('base.buyNow')}}</router-link>
        <div class="line"></div>
        <router-link class="detail_btn primary" v-if="list.Bargain==1" :to="{path:'/login'}">{{$t('base.makeOffer')}}</router-link>
        <router-link class="detail_btn" v-if="list.OrderType!=1" :to="{path:'/login'}">{{$t('base.addToWatch')}}</router-link>
      </div>
    </div>
    <!-- 賣家所在地 -->
    <div class="line address_from" v-if="list.OrderType!=1">
      <span class="ship" :class="list.BusinessType==2?'earth':''">{{$t('base.shipsFrom')}} {{setShipsFrom(list)}}</span>
      <span v-if="list.OrderType!=1">{{attentionCount(list.AttentionCount)}}</span>
    </div>
    <!-- 郵費 -->
    <div class="watchers" v-if="domesticCustom">
      <div class="DomesticCustom">
        <span class="price_name">{{$t('colon.shipping')}}</span>
        <div>
          <div class="Shipping" v-if="domesticCustom">
            <span v-if="domesticCustom.Status==1">{{$t('base.freeShipping')}}</span>
            <span :class="list.MemberSource!='US'?'business':''" v-if="domesticCustom.Status==2">{{list.MemberSource!='US'?$t('alert.PaidOnDelivery'):$t('base.payOnDelivery')}}</span>
            <span v-if="domesticCustom.Status==3">{{areaSymbol}} {{domesticCustom.USD_Price}}</span>
          </div>
          <div class="hengxian" v-if="list.MemberSource=='US'||list.OrderType==1"></div>
          <span class="text_blue see see_details" @click="domVisible=true" v-if="list.MemberSource=='US'||list.OrderType==1">{{$t('base.seeDetails')}}</span>
        </div>
      </div>
      <!-- <span class="text_blue see isUS" @click="IsUS">{{$t('base.ifSellerNoUSA')}}</span> -->
      <div class="text_gray" v-if="list.Address">{{$t('colon.located')}}
        {{setShipsFrom(list)}}</div>
    </div>
    <!-- 服務費 -->
    <div class="watchers" v-if="ServiceFee>0">
      <div class="Premium">
        <span class="price_name">{{$t('colon.buyerPremium')}}</span>
        <div>
          <span>{{areaSymbol}} {{ServiceFee}} {{SPercent}}</span>
          <!-- <span class="del" v-if="Discount>0">$ {{Discount}} {{DPercent}}</span> -->
        </div>
        <!-- <span class="Promotion" v-if="Discount>0">{{$t('base.promotion')}}</span> -->
        <div class="hengxian"></div>
        <span class="text_blue see see_details" @click="IsPremium(2)">{{$t('base.seeDetails')}}</span>
      </div>
    </div>
    <!-- 稅 -->
    <div class="watchers" v-if="userInfo!=null&&TaxServiceFee!=null">
      <div class="Premium">
        <span class="price_name">{{$t('colon.stateTax')}} </span>
        <!-- <div class="tax_price">
          <span>{{$t('base.accordToShipAddress')}}</span>
          <span class="tax_price_Promotion">
            <span class="Promotion">{{$t('base.promotion')}}</span>{{TaxSPercent}} {{$t('base.inPromotionPeriod')}}
          </span>
        </div> -->
        <div>
          <span>{{areaSymbol}} {{TaxServiceFee}} {{TaxSPercent}}</span>
          <!-- <span class="del" v-if="TaxDiscount>0">$ {{TaxDiscount}} {{TaxDPercent}}</span> -->
        </div>
        <!-- <span class="Promotion">Promotion</span> -->
        <div class="hengxian"></div>
        <span class="text_blue see see_details" @click="IsPremium(3)">{{$t('base.seeDetails')}}</span>
      </div>
      <div class="text_oversea" v-if="userInfo!=null&&(list.MemberSource!=userInfo.MemberSource&&userInfo.MemberSource!='MO')">{{$t('alert.willBeOversea')}}</div>
    </div>
    <cart-dialog :makeVisible="cartVisible" :list="list" :userInfo="userInfo" @getDialog="cartDialog" v-if="list.OrderType==1&&cartVisible" />
    <make-offer :makeVisible="dialogVisible" @getDialog="getDialog" :list="list" v-if="list.Bargain==1&&list!=null" />
    <domestic :domVisible="domVisible" :list="list" v-if="list!=null" @getDialog="SetDomDialog" />
    <get-change title="Add Phone Number" :domVisible='dislogType.changePhone' type="1" :userInfo="userInfo" @closeDialog="closeDialog" v-if='dislogType.changePhone' />
    <get-address v-if="dislogType.commodityaddress" :dialogVisible.sync="dislogType.commodityaddress" @closeDialog="closeDialog" :userInfo.sync="userInfo" />
    <jumio-verify-us title="ID Verification" :domVisible="dislogType.verifynow" @closeDialog="closeDialog" v-if='dislogType.verifynow' />
    <jumio-verify title="ID Verification" :domVisible="dislogType.idverification" @closeDialog="closeDialog" @openCloseDialog="openCloseDialog" v-if='dislogType.idverification' />
  </div>
</template>
<script>
import { countDown, getInfo, getTime, setUTC, numMulti, isNumber, priceExchange, isUserDomest } from "@/api/public";
import MakeOffer from "@/components/dialog/makeoffer"; // 一口價
import CartDialog from "@/components/dialog/cartdialog"; // 購物車
import Domestic from "@/components/dialog/domestic"; // 郵費模板
import GetChange from "@/components/dialog/changePhone"; // 修改手机号或邮箱
import GetAddress from "@/components/dialog/commodityaddress"; // 收货地址
import qs from 'qs'
export default {
  name: 'auction',
  components: { MakeOffer, CartDialog, Domestic, GetChange, GetAddress },
  data() {
    return {
      agencyProvice: null,
      areaSymbol: this.$store.state.areaSymbol,
      domesticCustom: null,
      isWatchlist: this.list.IsAttention != 0 ? true : false,
      watchName: this.$t('base.addToWatch'),
      dislogType: this.$enumInfo.dislogType,
      userInfo: null,
      domVisible: false,
      dialogVisible: false,
      bidsTabs: 0,
      input: "1",
      cartVisible: false,
      disabled: false,
      timer: "",
      nowData: new Date().getTime(),
      ServiceFee: null,
      Discount: null,
      SPercent: null,
      DPercent: null,
      TaxServiceFee: null,
      TaxDiscount: null,
      TaxSPercent: null,
      TaxDPercent: null,
    }
  },
  props: {
    list: {},
  },
  watch: {
    'list': {
      handler(obj) {
        this.domesticCustom = isUserDomest(this.userInfo, this.list.DomesticCustom, this.list.MemberSource, this.agencyProvice)
        this.GetServiceFee();
      }
    }
  },
  filters: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
  },
  mounted() {},
  created() {
    if (this.isWatchlist) {
      this.watchName = this.$t('base.watching')
    }
    this.userInfo = getInfo()
    if (this.userInfo != null) {
      this.GetAgency(this.list)
    }
    this.cardTimer()
  },
  methods: {
    // 关闭并打开其他弹框
    openCloseDialog(openVal, closeVal, openBol, closeBol) {

      this.dislogType[openVal] = openBol;
      this.dislogType[closeVal] = closeBol;
    },
    setShipsFrom(obj) {
      var address = obj.Address
      if (obj.MemberSource == 'CN') {
        address = 'China'
      }
      if (obj.MemberSource == 'HK') {
        address = 'Hong Kong'
      }
      if (obj.MemberSource == 'MO') {
        address = 'Macao'
      }
      if (obj.MemberSource == 'TW') {
        address = 'China'
      }
      return address
    },

    GetAgency(obj) {
      let that = this
      // console.log(obj.MemberSource, 'obj')
      if (obj.MemberSource != that.userInfo.MemberSource) {
        let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, memberSource: obj.MemberSource }
        this.$get(this.$interface.GetAgency, data).then(res => {
          if (res.result != 0) {
            that.agencyProvice = res.data
            that.domesticCustom = isUserDomest(that.userInfo, that.list.DomesticCustom, that.list.MemberSource, res.data)
          }
        })
      } else {
        this.domesticCustom = isUserDomest(that.userInfo, that.list.DomesticCustom, that.list.MemberSource, null)
      }

      this.GetServiceFee();
    },
    // 用户来源对应服务费列表
    GetServiceList() {
      let that = this;
      let SellMemberSource = that.list.MemberSource
      let BuyMemberSource = that.userInfo.MemberSource
      let data = { buyerSource: BuyMemberSource, operator_id: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken }
      // console.log(data, 'DPercent')
      that.$get(that.$interface.GetServiceList, data).then(res => {
        if (res.result != 0) {
          var result = res.data
          result.map(item => {

            //console.log(item)
            var PayType = 'Stripe'
            if (BuyMemberSource == "MO") {
              PayType = 'MPay'
            }
            // console.log(item.BuyerSource == BuyMemberSource, item.BuyerSource, BuyMemberSource, 1)
            // console.log(item.SellerSource == SellMemberSource, item.SellerSource, SellMemberSource, 2)
            // console.log(item.PayType == PayType, item.PayType, PayType, 3)
            if (item.BuyerSource == BuyMemberSource && item.SellerSource == SellMemberSource && item.PayType == PayType) {
              that.SPercent = item.Fee != 0 ? '(' + (numMulti(item.Fee, 100)) + '%)' : '(0%)'
              that.$root.$emit("SPercent", (numMulti(item.Fee, 100)));
              that.DPercent = item.Discount != 0 ? '(' + (numMulti(item.Discount, 100)) + '%)' : '(0%)'
              //console.log(that.SPercent, that.DPercent, 3)
            }
          })
          //console.log(res.data)
        }
      })
    },
    // 税
    GetTaxPrice() {
      let that = this;
      if (this.userInfo != null) {
        if (that.userInfo.Count > 0) {
          let data = { commodityId: this.list.ID, StateName: that.userInfo.State, operator_id: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken }
          that.$get(that.$interface.GetTaxPrice, data).then(res => {
            if (res.result != 0) {
              that.TaxServiceFee = priceExchange(res.data.TaxPrice, 'USD')
              that.TaxDiscount = priceExchange(res.data.Discount, 'USD')
              that.TaxSPercent = res.data.TaxPercent != 0 ? '(' + (numMulti(res.data.TaxPercent, 100)) + '%)' : '(0%)'
              that.TaxDPercent = res.data.DiscountPercent != 0 ? '(' + (numMulti(res.data.DiscountPercent, 100)) + '%)' : '(0%)'
            }
          })
        }
      }
    },
    // 服务费
    GetServiceFee() {
      let that = this;
      if (this.list && this.userInfo != null && this.list.OrderType != 1) {
        this.domesticCustom = isUserDomest(this.userInfo, this.list.DomesticCustom, this.list.MemberSource, this.agencyProvice)
        that.GetTaxPrice()
        that.GetServiceList()
        //var DomesticPrice = this.list.DomesticCustom[0].Price || 0
        var DomesticPrice=0
        try{
          DomesticPrice = that.domesticCustom.Price
        }catch(error){}
        var isGuareent = this.userInfo.MemberSource == "MO" ? 9 : 6
        let data = { memberId: this.userInfo.MappingUserId, commodityId: this.list.ID, postageMoney: DomesticPrice, isGuareent: isGuareent, operator_id: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken }
        that.$get(that.$interface.GetServiceFeeByCommodityID, data).then(res => {
          if (res.result != 0) {
            that.ServiceFee = priceExchange(res.data.ServiceFee, 'USD')
            that.Discount = priceExchange(res.data.Discount, 'USD')
          }
        })
      }
    },
    attentionCount(val) {
      let count = isNumber(val)
      if (count <= 1) {
        return count + " " + this.$t('base.watcher')
      } else {
        return count + " " + this.$t('base.watchers')
      }
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    // 获取倒计时
    CountDown(itemEnd, val) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let i = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      if (val == 0) {
        if (countDown(i, newval) == "00:00") {
          this.$emit('acution')
        }
      }
      //console.log(i, newval, itemEnd)
      //console.log(itemEnd)
      return countDown(i, newval)
    },

    getCountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let i = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(i, newval, 0)
    },
    //mousemove/mouseout
    //关注类型
    setwatch(val, type) {
      let that = this
      let isWatch = val
      if (isWatch) {
        that.watchName = that.$t('base.watching')
        if (type) {
          that.watchName = that.$t('base.unWatch')
        }
      } else {
        that.watchName = that.$t('base.addToWatch')
      }
    },
    // 判断默认地址是否为空
    isAddCout() {
      let that = this
      if (that.userInfo.VerifyStatus == 2) {
        if (!this.userInfo.TelPhone) {
          this.isTelPhone()
        } else {
          this.$confirm(that.$t('alert.noAddress'), that.$t('base.somethingImportant'), {
            confirmButtonText: that.$t('base.goToSet'),
            cancelButtonText: that.$t('base.cancel'),
            lockScroll: false
          }).then(() => {

            that.dislogType['commodityaddress'] = true;
            // let url = this.$router.resolve({ path: '/mycardhobby/setting' })
            // window.open(url.href, '_blank');
          }).catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除'
            // });          
          });
        }
      } else {
        // that.title = 'ID Verification'
        that.dislogType['idverification'] = true;
      }
    },
    // 判断用户是否存在手机号
    isTelPhone() {

      this.dislogType['changePhone'] = true;
      // this.$confirm('Please set your Phone number!', 'Something Important', {
      //   confirmButtonText: 'Go to Set',
      //   cancelButtonText: 'Cancel',
      //   lockScroll: false
      // }).then(() => {
      //   let url = this.$router.resolve({ path: '/mycardhobby/setting' })
      //   window.open(url.href, '_blank');
      // }).catch(() => {
      //   // this.$message({
      //   //   type: 'info',
      //   //   message: '已取消删除'
      //   // });          
      // });
    },
    // 关闭添加手机号弹框
    closeDialog(val, bol, type) {
      this.dislogType[val] = bol;
      if (type == 1) {
        this.userInfo = getInfo()
      }
      if (type == 'commodity') {
        this.userInfo = getInfo()
        this.$emit('updateDetail')
      }
    },
    // buyitnow
    buyItNow() {
      let that = this;
      //一口價
      let data = {
        "HeadPortrait": "https://bucket-katao.oss-cn-hangzhou.aliyuncs.com/touxiang.png",
        "SellRealName": this.list.SellRealName,
        "BuyerWyAccId": this.userInfo.MappingUserId,
        "SellerWyAccId": this.list.SellUserID,
        "Details": [{
          "ID": this.list.ID,
          "Title": this.list.Title,
          "TitImg": this.list.TitImg,
          "USD_Price": this.list.USD_Price,
          "World_Price": this.list.Price
        }],
        'OrderType': this.list.OrderType,
        "USD_PostageMoney": this.list.PostageMoney,
        "USD_TotalPrice": this.list.USD_Price,
        "World_TotalPrice": this.list.Price
      }
      window.sessionStorage.setItem('check', JSON.stringify(data))
      this.$router.push({
        name: 'Checkout'
      })
    },
    // 直接购买
    goto() {
      let that = this
      if (that.userInfo.VerifyStatus == 2) {
        if (this.userInfo.Count > 0) {
          if (!this.userInfo.TelPhone) {
            this.isTelPhone()
          } else {
            this.buyItNow()
          }

        } else {
          this.isAddCout()
        }
      } else {

        // that.title = 'ID Verification'
        that.dislogType['idverification'] = true;
      }
    },
    // 关注商品
    setAttention() {
      let that = this;
      if (that.userInfo != null) {
        let data = { 'commodityid': that.list.ID, 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId }
        this.$post(that.$interface.SetAttention, qs.stringify(data)).then(res => {
          if (res.result != 0) {
            that.isWatchlist = !that.isWatchlist

            that.watchName = that.$t('base.addToWatch')
            if (that.isWatchlist) {
              that.watchName = that.$t('base.watching')
            }
          }
        })
      }
    },
    cartDialog(val) {
      this.cartVisible = val
    },
    // 弹框关闭
    getDialog(val) {
      this.dialogVisible = val
    },
    SetDomDialog(val) {
      this.domVisible = val
    },
    IsUS() {
      this.$emit('isus')
    },
    IsPremium(val) {
      this.$emit('ispremium', val)
    }

  }
}

</script>
<style scoped>
@import "../../../static/css/buynow.css";

.address_from span {
  display: block;
}

.address_from span:first-child {
  margin-bottom: 16px;
}

.address_from span.earth {
  background: url(/static/images/icon/icon_earth.svg) no-repeat;
  padding-left: 23px;
}

.text_gray {
  margin-left: 96px;
}

.text_gray {
  margin-top: 10px;
}

.OrderType {
  color: #5F6DAE;
}

.OrderType span {
  margin-left: 24px;
}

/* /deep/.detail_ipt.el-input-number .el-input__inner{
  height: 40px;
} */
/deep/.detail_ipt.el-input-number {
  line-height: 34px;
}

/* /deep/.detail_ipt .el-input-number__decrease.is-disabled{
    color: #C0C4CC;
    background: #f7f7f7;
}
/deep/.detail_ipt .el-input-number__decrease:hover.is-disabled {
    color: #C0C4CC;
    background: #f7f7f7;
} */

</style>



// WEBPACK FOOTER //
// src/components/detail/buynow.vue